import React from 'react'
import CountUp from 'react-countup';
import Footer from './Footer'

export default function Aboutus() {
  const premiumBooked = (Math.random() * 0.5 + 0.5).toFixed(1); // Random between 0.5 and 1.0 billion
  const customerRatings = (Math.random() * 0.5 + 4.5).toFixed(1); // Random between 4.5 and 5.0
  const evaluationsMade = Math.floor(Math.random() * 1000000 + 2000000); // Random between 2,000,000 and 3,000,000
  const livesSafeguarded = Math.floor(Math.random() * 5000 + 10000); // Random between 10,000 and 15,000

  return (
    <div>

      <div className='col-12'>
       
      </div>

      <div className="page-wrapper bg-light p-t-100 p-b-50">
        <div className="wrapper wrapper--w900">
            <div className="card card-6">
                <div className="card-heading">
                    <h1 className="title">ABOUT INSURANCE ADVISORS</h1>
        </div>

        <div className="card-body">
        <p className='pr1'>
  Meet our passionate team,driven by a shared commitment to delivering excellence in every interaction.We believe in transparency,ensuring you have a clear understanding of your coverage option.
  Our mission is to provide personalized solutions that align with your unique needs and goals.As your Insurance partners,we understand the importance of safeguarding what matters most to you.
</p>
</div>

<div>
<p className='pr1'>
    Our holistic approach goes beyond policies-we build lasting relationships based on trust and integrity.
    From life Life to Health and everything in between,our advisors navigate the insurance landscape with expertise.
    Your peace of mind is our priority.We tailor solutions to protect you and your loved ones.Explore a range of insurance products curated to suit various lifestyles and financial objectives.
</p>
</div>

<div>
<p className='pr1'>
  We empower you with knowledge,demystifying insurance jargon to make informed decisions.
  Our dedication to client satisfaction drives us to continually enhance and evolve our services.
  We pride ourselves on being accessible,ensuring you have a reliable partner in every insurance decision.
  We go beyond policies,offering insights and advice to help you plan for a secure future.
<br/><br/>
Insurance Advisors welcomes you to enjoy their services.
</p>
    </div>
    </div>
    </div>
    

    <div className="bg-custom">

    <h1 className="choose">WHY CHOOSE US</h1>
    <br></br>
    <div class="container">
  <div class="row">
    <div class="col-sm-4">
      <div id="mid">
      <img src= './assets/img/icon-no-6.png' /></div>
      <br/><div id="mid"><h5 className='txt_2'> 100% Free </h5></div>
     <div id="mid"> <p className='txt_2'> Everything we share and suggest<br></br> doesn't cost anything.</p></div>
    </div>
    <div class="col-sm-4">
      <div id="mid">
     <img src= './assets/img/icon-no-1.png' /></div>
     <br/><div id="mid"><h5 className='txt_2'> Transparency </h5></div>
    <div id="mid"><p className='txt_2'> We help you with what you need<br></br> not what we want you to know. </p></div> 
    </div>
    <div class="col-sm-4">
      <div id="mid">
      <img src='./assets/img/icon-no-2.png'/></div>
      <br/><div id="mid"><h5 className='txt_2'> Top Rated Partners </h5></div>
     <div id="mid"><p className='txt_2'> We have the best insurance<br></br> companies on our platform. </p></div> 
    </div>
  </div>
</div>
 </div>
    </div>

    <div className="achievements-section">
      <h1 className="achievements-title">OUR ACHIEVEMENTS</h1>
      <p className="achievements-subtitle">Celebrating our milestones!</p>
      <div className="achievements-container">
        {/* Card 1 */}
        <div className="achievement-card">
          <p className="achievement-text">Premium Booked</p>
          <h3 className="achievement-number">
            <CountUp start={0} end={parseFloat(premiumBooked)} decimals={1} suffix=" billion+" duration={3} />
          </h3>
        </div>

        {/* Card 2 */}
        <div className="achievement-card">
          <p className="achievement-text">Customer Ratings</p>
          <h3 className="achievement-number">
            <CountUp start={0} end={parseFloat(customerRatings)} decimals={1} duration={3} />+ 
          </h3>
        </div>

        {/* Card 3 */}
        <div className="achievement-card">
          <p className="achievement-text">Evaluations Made</p>
          <h3 className="achievement-number">
            <CountUp start={0} end={evaluationsMade} separator="," duration={3.5} />
          </h3>
        </div>

        {/* Card 4 */}
        <div className="achievement-card">
          <p className="achievement-text">Lives Safeguarded</p>
          <h3 className="achievement-number">
            <CountUp start={0} end={livesSafeguarded} separator="," duration={3} />+
          </h3>
        </div>
      </div>
    </div>
    <br/>
    <Footer></Footer>
</div>
  )
}
